export const SENSITIVE_RE =
  /secret|password|passwd|token|apikey|api_key|private|credential|auth|_key$/i;

export const KEY_RE = /^[A-Z_][A-Z0-9_]{0,254}$/;
export const RESERVED = ["PORT", "AVAHANA_"];

export function isSensitive(key: string): boolean {
  return SENSITIVE_RE.test(key);
}

export function validateKey(key: string): string | null {
  if (!key) return "Key is required";
  if (!KEY_RE.test(key))
    return "Keys must be uppercase letters, digits, and underscores (e.g. DATABASE_URL)";
  if (RESERVED.some((r) => key === r || key.startsWith(r)))
    return `"${key}" is reserved by the platform`;
  return null;
}

export function parseDotEnv(raw: string): {
  valid: Record<string, string>;
  skipped: string[];
} {
  const valid: Record<string, string> = {};
  const skipped: string[] = [];

  for (const line of raw.split("\n")) {
    const trimmed = line.trim();
    if (!trimmed || trimmed.startsWith("#")) continue;

    const eqIdx = trimmed.indexOf("=");
    if (eqIdx === -1) {
      skipped.push(line);
      continue;
    }

    const key = trimmed.slice(0, eqIdx).trim();
    let value = trimmed.slice(eqIdx + 1).trim();

    if (
      (value.startsWith('"') && value.endsWith('"')) ||
      (value.startsWith("'") && value.endsWith("'"))
    ) {
      value = value.slice(1, -1);
    }

    if (validateKey(key)) {
      skipped.push(line);
    } else {
      valid[key] = value;
    }
  }

  return { valid, skipped };
}
